import { useSearch } from '@tanstack/react-router';
import type { z } from 'zod';
import type { AbsolutePath, DefinedPath, Layout } from './definePath';

// The DSL builds the route tree from `AnyRoute`, so TanStack's `useSearch({ from })`
// is `any`. Recover the type from the path's zod `search` schema instead.
export function useRouteSearch<L extends Layout, P extends AbsolutePath, S extends z.ZodType>(path: DefinedPath<L, P, S>): z.infer<S> {
  return useSearch({ from: path.id }) as z.infer<S>;
}
